  var swiper = new Swiper('.custom-media-slider', {
    autoplay: {
    delay: 3000,          // time between slides (ms)
    disableOnInteraction: false, // keep autoplay after user interaction
    pauseOnMouseEnter: true,     // pause on hover (optional)
  },
     scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        // Dynamically get the image source for each slide
        var imageSrc = document.querySelectorAll('.swiper-slide img')[index].src;
        return `<span class="${className}" style="background-image: url('${imageSrc}'); background-size: cover; background-position: center; width: 77px; height: 77px; display: inline-block; border-radius:0px; opacity:1;"></span>`;
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
        580: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
     },
  });